<template>
    <Avatar :size="size" :variant="variant" :name="name" :colors="boring_avatar_colors" />
</template>

<script>
import Avatar from 'vue-boring-avatars'
// https://boringavatars.com/d0d167-fffcff-e6dddc-ff0c66-969ba2
// https://www.npmjs.com/package/vue-boring-avatars

export default {
    name: 'UIAvatar',
    props: {
        name: {
            type: String,
            required: true,
        },
        size: {
            type: Number,
            default: 64,
        },
        variant: {
            type: String,
            default: 'beam',
        },
    },
    setup(props) {
        const boring_avatar_colors = ['#13141A', '#FFEED8', '#F1EBEB', '#E9FF21', '#FFC65A']

        return {
            boring_avatar_colors,
        }
    },
    components: {
        Avatar,
    },
}
</script>

<style scoped>
svg {
    display: inline-block;
}
</style>
